import {Module} from "vuex";

import {RootStateType} from "@/store";

import actions from "./actions";
import mutations from "./mutations";
import {TriggerImplementationState} from "./model";

let state: TriggerImplementationState = {
  triggerImplementations: []
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
} as Module<TriggerImplementationState, RootStateType>;
